var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2 as Grid, Typography, } from '@mui/material';
import React, { useMemo } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { z } from 'zod';
import { useDocumentValidation } from '../../hooks/useDocumentValidation';
import DocumentSection from '../Documento/DocumentSection';
import TextFieldControl from '../Form/TextFieldControl';
import { EntidadeAnalise } from '../../enums/analise.enum';
import { getDisabledFlags } from '../../util/analise.utils';
import { AnaliseGrupoStatusComponent } from '../Analise/AnaliseGrupoStatusComponent';
import { DateFieldControl } from '../Form/DateFieldControl';
var veiculoSchemaBase = z.object({
    placa: z
        .string()
        .min(1, 'Placa do veículo é obrigatória')
        .max(10, 'Placa excede o tamanho máximo permitido')
        .regex(/^[A-Z0-9-]+$/i, 'Placa deve conter apenas letras e números'),
    categoria: z.enum(['AAC', 'A', 'B', 'C', 'D', 'E'], {
        errorMap: function () { return ({
            message: 'Categoria inválida. Escolha entre AAC, A, B, C, D ou E.',
        }); },
    }),
    observacao: z
        .string()
        .max(500, 'Observação deve ter no máximo 500 caracteres')
        .optional(),
    dataInicioOperacao: z.coerce.date(),
    placaReboque: z.string().optional(),
});
var veiculoSchema = veiculoSchemaBase.superRefine(function (data, ctx) {
    if (data.categoria === 'E' &&
        (!data.placaReboque || data.placaReboque.trim() === '')) {
        ctx.addIssue({
            path: ['placaReboque'],
            code: z.ZodIssueCode.custom,
            message: 'Placa do reboque é obrigatória para veículos da categoria E',
        });
    }
});
var DEFAULT_VALUES = {
    placa: '',
    categoria: '',
    observacao: '',
    dataInicioOperacao: new Date(),
    placaReboque: '',
};
export var VeiculoModalForm = function (_a) {
    var _b, _c, _d;
    var open = _a.open, veiculo = _a.veiculo, servico = _a.servico, analise = _a.analise, modo = _a.modo, onClose = _a.onClose, onSave = _a.onSave;
    var _e = useForm({
        resolver: zodResolver(veiculoSchema),
        defaultValues: veiculo || DEFAULT_VALUES,
    }), control = _e.control, handleSubmit = _e.handleSubmit;
    var categoriaSelecionada = useWatch({
        control: control,
        name: 'categoria',
    });
    var disabled = useMemo(function () { return modo === 'visualizar'; }, [modo]);
    var disabledDadosGerais = getDisabledFlags(EntidadeAnalise.VEICULO, veiculo === null || veiculo === void 0 ? void 0 : veiculo.id, analise === null || analise === void 0 ? void 0 : analise.gruposCampos, disabled).disabledDadosGerais;
    var secoesDocumentos = (_c = (_b = servico === null || servico === void 0 ? void 0 : servico.secoesDocumentos) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return x.categoria === 'VEICULO'; })) !== null && _c !== void 0 ? _c : [];
    var _f = useDocumentValidation((_d = veiculo === null || veiculo === void 0 ? void 0 : veiculo.documentos) !== null && _d !== void 0 ? _d : []), documentosAnexados = _f.documentosAnexados, errorsDocumentos = _f.errors, validateAllSections = _f.validateAllSections, handleUpdateDocumento = _f.handleUpdateDocumento;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var allValid, veiculoData;
        return __generator(this, function (_a) {
            try {
                allValid = validateAllSections(secoesDocumentos);
                if (!allValid) {
                    console.error('Erros de validação encontrados:', allValid, errorsDocumentos);
                    return [2 /*return*/];
                }
                veiculoData = __assign(__assign({}, data), { documentos: documentosAnexados });
                if (onSave) {
                    onSave(veiculoData);
                }
                else {
                    onClose();
                }
            }
            catch (error) {
                console.error('Erro ao adicionar funcionário:', error);
            }
            return [2 /*return*/];
        });
    }); };
    var dialogTitle = useMemo(function () {
        switch (modo) {
            case 'adicionar':
                return 'Adicionar Veículo';
            case 'editar':
                return 'Editar Veículo';
            default:
                return 'Visualizar Veículo';
        }
    }, [modo]);
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "lg", children: [_jsx(DialogTitle, { children: dialogTitle }), _jsx(DialogContent, { children: _jsxs(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, children: [_jsx(Typography, { variant: "h6", children: "Informa\u00E7\u00F5es B\u00E1sicas" }), _jsx(AnaliseGrupoStatusComponent, { analise: analise, entidade: "VEICULO", grupo: "DADOS_GERAIS", entidadeAssociadaId: veiculo === null || veiculo === void 0 ? void 0 : veiculo.id, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "placa", label: "Placa", control: control, required: true, disabled: disabledDadosGerais || modo === 'editar', maxLength: 10 }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "categoria", label: "Categoria", control: control, required: true, disabled: disabledDadosGerais }) }), categoriaSelecionada === 'E' && (_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "placaReboque", label: "Placa do Reboque", control: control, required: true, disabled: disabledDadosGerais, maxLength: 10 }) })), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "observacao", label: "Observa\u00E7\u00E3o", control: control, required: true, disabled: disabledDadosGerais }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(DateFieldControl, { name: "dataInicioOperacao", label: "Data de In\u00EDcio da Opera\u00E7\u00E3o", control: control, required: true, disabled: disabledDadosGerais }) })] }) }), _jsx(Typography, { variant: "h6", sx: { mt: 3 }, children: "Documentos do Ve\u00EDculo" }), _jsx(Typography, { variant: "body2", color: "textSecondary", sx: { mb: 2 }, children: "Orientamos que o arquivo deve ser enviado no formato PDF, e o seu tamanho m\u00E1ximo n\u00E3o pode ultrapassar 5mb. Informe a data de validade de cada documento, caso o mesmo possua." }), secoesDocumentos.map(function (secao) { return (_jsx(DocumentSection, { secao: secao, disabled: disabled, analise: analise, documentosAnexados: documentosAnexados, onUpdateDocumento: handleUpdateDocumento, errors: errorsDocumentos[secao.id] }, secao.id)); })] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, children: "Cancelar" }), !disabled && (_jsx(Button, { variant: "contained", color: "primary", type: "submit", onClick: handleSubmit(onSubmit), children: "Salvar" }))] })] }));
};
